import { render, staticRenderFns } from "./Salesorderslist.vue?vue&type=template&id=3e3cdc7f&scoped=true&"
import script from "./Salesorderslist.vue?vue&type=script&lang=js&"
export * from "./Salesorderslist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3cdc7f",
  null
  
)

export default component.exports